import { useNavigate } from "react-router-dom";

import {
  useApproveProduct,
  usePatchProductStatus,
} from "../../../../api/products";
import useNotify from "../../../../hooks/useNotify";
import { PRODUCT_STATUS, isStatusApproved } from "../../../../models/Product";
import {
  rewardInventoryPortalPaths,
  rootPaths,
} from "../../../../routes/routePaths";
import { MODE } from "../../../../stores/formStore";
import { camelToCapitalisedWords } from "../../../../utils/string";

export const useUpdateProductStatus = () => {
  const {
    mutateAsync: mutatePatchProd,
    isLoading: loadingPatchProd,
    isSuccess: successPatchProd,
  } = usePatchProductStatus();
  const {
    mutateAsync: mutateApproveProd,
    isLoading: loadingApproveProd,
    isSuccess: successApproveProd,
  } = useApproveProduct();
  const { setNotifySuccess, setNotifyError } = useNotify();
  const isLoading = loadingApproveProd || loadingPatchProd;
  const isSuccess = successApproveProd || successPatchProd;

  const updateProductStatus = async (
    productId: string,
    productStatus: PRODUCT_STATUS,
    reason?: string,
  ) => {
    try {
      if (isStatusApproved(productStatus)) {
        await mutateApproveProd({
          productId,
        });
      } else {
        await mutatePatchProd({ productId, status: productStatus, reason });
      }
      setNotifySuccess(`Product: ${camelToCapitalisedWords(productStatus)}`);
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Could Not Update Product Status";
      setNotifyError(errorMessage);
    }
  };

  return { updateProductStatus, isLoading, isSuccess };
};

export const useProductNavigation = () => {
  const navigate = useNavigate();

  const navigateToProduct = (productId: string, mode: MODE) => {
    const path = `${
      rootPaths.rewardInventoryPortal
    }/${rewardInventoryPortalPaths.product.replace(":productId", productId)}`;

    navigate(path, { state: { mode } });
  };

  return { navigateToProduct };
};
